import { EAuthenticateStatus, ECreateStatus } from '../../types/social';
export function disabledSelector(state) {
  var _state$social = state.social,
    authenticateStatus = _state$social.authenticate.status,
    createStatus = _state$social.create.status;
  return authenticateStatus === EAuthenticateStatus.Loading || createStatus === ECreateStatus.Loading;
}
export function hasErrorSelector(state) {
  var _state$social2 = state.social,
    authenticateStatus = _state$social2.authenticate.status,
    createStatus = _state$social2.create.status;
  return createStatus === ECreateStatus.Failed || authenticateStatus === EAuthenticateStatus.Failed && createStatus === ECreateStatus.Succeed;
}
export function errorSelector(state) {
  if (!hasErrorSelector(state)) {
    return undefined;
  }
  var _state$social3 = state.social,
    authenticateError = _state$social3.authenticate.error,
    _state$social3$create = _state$social3.create,
    createStatus = _state$social3$create.status,
    createError = _state$social3$create.error;
  return createStatus === ECreateStatus.Failed ? createError : authenticateError;
}